import { Images, ThumbnailImages } from './models/images.model';

export const thumbnailImage: ThumbnailImages = {
  imageList: [
    { id: '1', image: 'fragile_myths_thumbnail', page: 'fragile.myths', function: 'FragileMyths' },
    { id: '2', image: 'decorative_thumbnail', page: 'decorative', function: 'Decorative' },
    { id: '3', image: 'profligacy_thumbnail', page: 'profligacy', function: 'Profligacy' },
    { id: '4', image: 'dream_big_thumbnail', page: 'dream.big', function: 'DreamBig' },
    { id: '5', image: 'expectations_thumbnail', page: 'expectations', function: 'Expectations' },
    { id: '6', image: 'excessive_thumbnail', page: 'excessive', function: 'Excessive' },
    { id: '7', image: 'self-fulfilling_prophecy_detail_thumbnail', page: 'self.fulfilling.prophecy', function: 'SelfFulfillingProphecy' },
    { id: '8', image: 'wild_seeds_thumbnail', page: 'wild.seeds', function: 'WildSeeds' },
    { id: '9', image: 'chain_reaction_thumbnail', page: 'chain.reaction', function: 'ChainReaction' },
    { id: '10', image: 'burdensome', page: 'burdensome', function: 'Burdensome' },
    { id: '11', image: 'the_weight_of_an_object_toms_thumbnail', page: 'the.weight.of.an.object', function: 'TheWeightOfAnObject' },
    { id: '12', image: 'projection_identification_empathy_thumbnail', page: 'projection.identification.empathy', function: 'ProjectionIdentificationEmpathy' },
    { id: '13', image: 'hands_tied_thumbnail', page: 'body.sculptures', function: 'BodySculptures' },
    { id: '15', image: 'osteoderm_thumbnail', page: 'osteoderm', function: 'Ostederm' },
    { id: '16', image: 'phalangeal_thelodonts_thumbnail', page: 'phalangeal.thelodonts', function: 'phalangealThelodonts' },
    { id: '17', image: 'defense_mechanism_thumbnail', page: 'defense.mechanism', function: 'DefenseMechanism' },
    { id: '18', image: 'epithelial_neoplasms_body_thumbnail', page: 'epithelial.neoplasms', function: 'EpithelialNeoplasms' },
    { id: '19', image: 'apothecia_body_thumbnail', page: 'apothecia', function: 'Apothecia' }
  ]
};

export const fragileMythsImage: Images = {
  title: 'Fragile Myths',
  imageList: [
    {
      id: '31',
      image: 'expressive_expansionisms',
      title: 'Expressive Expansionism',
      media: 'mulberry paper, cotton thread, methylcellulose',
      year: '2026',
      dimensions: "5' x 10' x 2'",
      description: 'Sewn construction sculpture of Victorian diamond chandelier earrings',
      orientation: 'portrait'
    },
    {
      id: '32',
      image: 'expressive_expansionisms_detail_a',
      title: 'Expressive Expansionism',
      media: 'mulberry paper, cotton thread, methylcellulose',
      year: '2026',
      dimensions: "5' x 10' x 2'",
      description: 'Sewn construction sculpture of Victorian diamond chandelier earrings',
      orientation: 'portrait'
    },
        {
      id: '33',
      image: 'expressive_expansionisms_detail_b',
      title: 'Expressive Expansionism',
      media: 'mulberry paper, cotton thread, methylcellulose',
      year: '2026',
      dimensions: "5' x 10' x 2'",
      description: 'Sewn construction sculpture of Victorian diamond chandelier earrings',
      orientation: 'portrait'
    },
    {
      id: '34',
      image: 'fragile_myths_I',
      title: 'Fragile Myths I',
      media: 'packaging paper, cotton thread, methylcellulose',
      year: '2024',
      dimensions: "4' x 8' x 1'",
      description: 'Sewn construction sculpture of Victorian chandelier earrings',
      orientation: 'portrait'
    },
    {
      id: '35',
      image: 'fragile_myths_I_detail',
      title: 'Fragile Myths I',
      media: 'packaging paper, cotton thread, methylcellulose',
      year: '2024',
      dimensions: "4' x 8' x 1'",
      description: 'Sewn construction sculpture of Victorian, chandelier earrings',
      orientation: 'portrait'
    }
  ]
};

export const profligacyImage: Images = {
  title: 'Profligacy',
  imageList: [
    {
      id: '36',
      image: 'profligacy',
      title: 'Profligacy',
      media: 'found fabric, fiber fill',
      year: '2018',
      dimensions: '90" x 52" x 13"',
      description: 'Sewn construction sculpture of Victorian chandelier earrings',
      orientation: 'portrait'
    },
    {
      id: '37',
      image: 'profligacy_body',
      title: 'Profligacy',
      media: 'found fabric, fiber fill',
      year: '2018',
      dimensions: '90" x 52" x 13"',
      description: 'Sewn construction sculpture of Victorian chandelier earrings',
      orientation: 'portrait'

    }
  ]
};

export const decorativeImage: Images = {
  title: 'Decorative',
  imageList: [
    {
      id: '38',
      image: 'decorative',
      title: 'Decorative',
      media: 'found fabric, fiber fill, steel wire',
      year: '2019',
      dimensions: '51" x 17" x 14"',
      description: 'Sewn construction apron based on Victorian chandelier earrings',
      orientation: 'portrait'
    },
    {
      id: '39',
      image: 'decorative_hanging',
      title: 'Decorative',
      media: 'found fabric, fiber fill, steel wire',
      year: '2019',
      dimensions: '51" x 17" x 14"',
      description: 'Sewn construction apron based on Victorian chandelier earrings',
      orientation: 'portrait'
    },
    {
      id: '40',
      image: 'decorative_on_body',
      title: 'Decorative',
      media: 'found fabric, fiber fill, steel wire',
      year: '2019',
      dimensions: '51" x 17" x 14"',
      description: 'Sewn construction apron based on Victorian chandelier earrings',
      orientation: 'portrait'
    }
  ]
};

export const dreamBigImage: Images = {
  title: 'Dream Big',
  imageList: [
    {
      id: '41',
      image: 'dream_big',
      title: 'Dream Big',
      media: 'cotton fabric, polyester mesh fabric, vinyl, thread, wooden dowels, steel wire',
      year: '2018',
      dimensions: "10' x 6' x 3.5'",
      description: 'An installation of textile buildings and objects created in collaboration with art classes at the Academy of Entreprenuership Studies Middle School in St. Louis, MO through a Mural Arts project made possible by Craft Alliance. The fabric, was hand-dyed, embroidered, and machine sewn. The design was created by and selected by the students.',
      orientation: 'landscape'
    },
    {
      id: '42',
      image: 'dream_big_left',
      title: 'Dream Big',
      media: 'cotton fabric, polyester mesh fabric, vinyl, thread, wooden dowels, steel wire',
      year: '2018',
      dimensions: "10' x 6' x 3.5'",
      description: 'An installation of textile buildings and objects created in collaboration with art classes at the Academy of Entreprenuership Studies Middle School in St. Louis, MO through a Mural Arts project made possible by Craft Alliance. The fabric, was hand-dyed, embroidered, and machine sewn. The design was created by and selected by the students.',
      orientation: 'landscape'
    },
    {
      id: '43',
      image: 'dream_big_right',
      title: 'Dream Big',
      media: 'cotton fabric, polyester mesh fabric, vinyl, thread, wooden dowels, steel wire',
      year: '2018',
      dimensions: "10' x 6' x 3.5'",
      description: 'An installation of textile buildings and objects created in collaboration with art classes at the Academy of Entreprenuership Studies Middle School in St. Louis, MO through a Mural Arts project made possible by Craft Alliance. The fabric, was hand-dyed, embroidered, and machine sewn. The design was created by and selected by the students.',
      orientation: 'landscape'
    }
  ]
};

export const expectationsImage: Images = {
  title: 'Expectations',
  imageList: [
    {
      id: '44',
      image: 'expectations_body',
      title: 'Expectations',
      media: 'found fabric, fiber fill',
      year: '2017',
      dimensions: '18" x 36" x 18"',
      description: 'Sewn construction sculpture based on a diamond engagement ring',
      orientation: 'portrait'
    },
    {
      id: '45',
      image: 'expectations_body_2',
      title: 'Expectations',
      media: 'found fabric, fiber fill',
      year: '2017',
      dimensions: '18" x 36" x 18"',
      description: 'Sewn construction sculpture based on a diamond engagement ring',
      orientation: 'portrait'
    },
    {
      id: '46',
      image: 'expectations',
      title: 'Expectations',
      media: 'found fabric, fiber fill',
      year: '2017',
      dimensions: '18" x 36" x 18"',
      description: 'Sewn construction sculpture based on a diamond engagement ring',
      orientation: 'landscape'
    },
    {
      id: '47',
      image: 'expectations_2',
      title: 'Expectations',
      media: 'found fabric, fiber fill',
      year: '2017',
      dimensions: '18" x 36" x 18"',
      description: 'Sewn construction sculpture based on a diamond engagement ring',
      orientation: 'landscape'
    }
  ]
};

export const excessiveImage: Images = {
  title: 'Excessive',
  imageList: [
    {
      id: '48',
      image: 'excessive_body',
      title: 'Excessive',
      media: 'ceramic',
      year: '2017',
      dimensions: '11" x 18" x 15"',
      description: 'Slab construction sculpture based on a diamond engagement ring',
      orientation: 'portrait'
    },
    {
      id: '49',
      image: 'excessive',
      title: 'Excessive',
      media: 'ceramic',
      year: '2017',
      dimensions: '11" x 18" x 15"',
      description: 'Slab construction sculpture based on a diamond engagement ring',
      orientation: 'landscape'
    }
  ]
};

export const selfFulfillingProphecyImage: Images = {
  title: 'Self-fulfilling Prophecy',
  imageList: [
    {
      id: '50',
      image: 'self-fulfilling_prophecy',
      title: 'Self-fulfilling Prophecy',
      media: 'sterling silver, brass, bronze, copper',
      year: '2017',
      dimensions: '4" x 4" x 1"',
      description: 'A tension-fitted container with a hollow-constructed brooch as the lid. The brooch is interactive in that some of the petals can be plucked from the flower.',
      orientation: 'landscape'
    },
    {
      id: '51',
      image: 'self-fulfilling_prophecy_back',
      title: 'Self-fulfilling Prophecy',
      media: 'sterling silver, brass, bronze, copper',
      year: '2017',
      dimensions: '4" x 4" x 1"',
      description: 'A tension-fitted container with a hollow-constructed brooch as the lid. The brooch is interactive in that some of the petals can be plucked from the flower.',
      orientation: 'landscape'
    },
    {
      id: '52',
      image: 'self-fulfilling_prophecy_detail',
      title: 'Self-fulfilling Prophecy',
      media: 'sterling silver, brass, bronze, copper',
      year: '2017',
      dimensions: '4" x 4" x 1"',
      description: 'A tension-fitted container with a hollow-constructed brooch as the lid. The brooch is interactive in that some of the petals can be plucked from the flower.',
      orientation: 'landscape'
    }
  ]
};

export const wildSeedsImage: Images = {
  title: 'Wild Seeds',
  imageList: [
    {
      id: '53',
      image: 'wild_seeds',
      title: 'Wild Seeds',
      media: 'sterling silver, brass, bronze, copper',
      year: '2017',
      dimensions: '2.5" x 3" x 1"',
      description: "A riveted brooch composed of Queen Anne's Lace and contaceptive pills",
      orientation: 'landscape'
    },
    {
      id: '54',
      image: 'wild_seeds_back',
      title: 'Wild Seeds',
      media: 'sterling silver, brass, bronze, copper',
      year: '2017',
      dimensions: '2.5" x 3" x 1"',
      description: "A riveted brooch composed of Queen Anne's Lace and contaceptive pills",
      orientation: 'landscape'
    }
  ]
};

export const chainReactionImage: Images = {
  title: 'Chain Reaction',
  imageList: [
    {
      id: '55',
      image: 'chain_reaction',
      title: 'Chain Reaction',
      media: 'copper, enamel, sterling silver',
      year: '2016',
      dimensions: '12" x 12" x 0.5"',
      description: 'A necklace detailing the effects of energy use on climate change',
      orientation: 'portrait'
    },
    {
      id: '56',
      image: 'chain_reaction_thumbnail',
      title: 'Chain Reaction',
      media: 'copper, enamel, sterling silver',
      year: '2016',
      dimensions: '12" x 12" x 0.5"',
      description: 'A necklace detailing the effects of energy use on climate change',
      orientation: 'portrait'
    }
  ]
};

export const theWeightOfAnObjectImage: Images = {
  title: 'The Weight of an Object',
  imageList: [
    {
      id: '57',
      image: 'the_weight_of_an_object_toms_body',
      title: 'The Weight of an Object',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Three public, interactive performances in Lawrence, KS. Through a multimedia, sculptural interface participants will be able to physically experience the metaphorical weight of a set of consumer objects – an iPhone, a pair of TOM’s shoes, and a KU t-shirt. Participants will be encouraged to tow the entire structure containing the weight of the item’s origins and history.',
      orientation: 'landscape'    
    },
    {
      id: '58',
      image: 'the_weight_of_an_object_tshirt_body',
      title: 'The Weight of an Object',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Three public, interactive performances in Lawrence, KS. Through a multimedia, sculptural interface participants will be able to physically experience the metaphorical weight of a set of consumer objects – an iPhone, a pair of TOM’s shoes, and a KU t-shirt. Participants will be encouraged to tow the entire structure containing the weight of the item’s origins and history.',
      orientation: 'landscape'
    },
    {
      id: '59',
      image: 'the_weight_of_an_object_toms',
      title: 'The Weight of an Object',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Three public, interactive performances in Lawrence, KS. Through a multimedia, sculptural interface participants will be able to physically experience the metaphorical weight of a set of consumer objects – an iPhone, a pair of TOM’s shoes, and a KU t-shirt. Participants will be encouraged to touch the object and pull it out of the display area, but as they do so they will have to tow the entire structure containing the weight of the item’s origins and history.',
      orientation: 'landscape'
    },
    {
      id: '60',
      image: 'the_weight_of_an_object_toms_viewers_1',
      title: 'The Weight of an Object',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Three public, interactive performances in Lawrence, KS. Through a multimedia, sculptural interface participants will be able to physically experience the metaphorical weight of a set of consumer objects – an iPhone, a pair of TOM’s shoes, and a KU t-shirt. Participants will be encouraged to tow the entire structure containing the weight of the item’s origins and history.',
      orientation: 'landscape' 
    },
    {
      id: '61',
      image: 'the_weight_of_an_object_toms_detail',
      title: 'The Weight of an Object',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Three public, interactive performances in Lawrence, KS. Through a multimedia, sculptural interface participants will be able to physically experience the metaphorical weight of a set of consumer objects – an iPhone, a pair of TOM’s shoes, and a KU t-shirt. Participants will be encouraged to tow the entire structure containing the weight of the item’s origins and history.',
      orientation: 'landscape'
    },
    {
      id: '62',
      image: 'the_weight_of_an_object_tshirt',
      title: 'The Weight of an Object',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Three public, interactive performances in Lawrence, KS. Through a multimedia, sculptural interface participants will be able to physically experience the metaphorical weight of a set of consumer objects – an iPhone, a pair of TOM’s shoes, and a KU t-shirt. Participants will be encouraged to tow the entire structure containing the weight of the item’s origins and history.',
      orientation: 'landscape'
    },
    {
      id: '63',
      video: 'https://player.vimeo.com/video/130648404?h=2ac76ecc2b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'The Weight of an Object: TOMs',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Video of public, interactive performances in Lawrence, KS. Through a multimedia, sculptural interface participants will be able to physically experience the metaphorical weight of a set of consumer objects – an iPhone, a pair of TOM’s shoes, and a KU t-shirt. Participants will be encouraged to touch the object and pull it out of the display area, but as they do so they will have to tow the entire structure containing the weight of the item’s origins and history.'
    },
    {
      id: '64',
      video: 'https://player.vimeo.com/video/124864282?h=5e698d6a96&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'The Weight of an Object: iPhone',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Video of participants discussing the item’s origins and history which was displayed through the back of the structureduring the performances.'
    },
    {
      id: '65',
      video: 'https://player.vimeo.com/video/126531890?h=90578f89c8&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'The Weight of an Object: TOMs',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Video of participants discussing the item’s origins and history which was displayed through the back of the structureduring the performances.'
    },
    {
      id: '66',
      video: 'https://player.vimeo.com/video/130635171?h=af69d6b35d&;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'The Weight of an Object: TOMs',
      media: 'multimedia: acrylic, steel, found objects, video',
      year: '2015',
      dimensions: "6' x 9' x 5'",
      description: 'Video of participants discussing the item’s origins and history which was displayed through the back of the structureduring the performances.'
    }
  ]
};

export const projectionIdentificationEmpathyImage: Images = {
  title: 'projection...identification...empathy',
  imageList: [
    {
      id: '67',
      image: 'codependency_studio',
      title: 'Codependency',
      media: 'stainless steel, wool, plastic, leather',
      year: '2013',
      dimensions: "2' x 7' x 2'",
      description: 'A wearable, body-specific sculpture representing the pysical manifestation of emotional dependence on another person through linking the bodies together in an inexorable way',
      orientation: 'landscape'
    },
    {
      id: '68',
      image: 'self-incarceration_studio',
      title: 'Self-incarceration',
      media: 'stainless steel, wool, plastic, silicone, leather',
      year: '2013',
      dimensions: "7' x 2.5' x 2.5'",
      description: 'A wearable, body-specific sculpture representing the pysical manifestation of emotional isolation through a body-sized cage surrounding the body',
      orientation: 'portrait'
    },
    {
      id: '69',
      image: 'chagrin_studio',
      title: 'Chagrin',
      media: 'stainless steel, wool, silicone, aluminum, leather',
      year: '2013',
      dimensions: "5' x 2' x 2'",
      description: 'A wearable, body-specific sculpture representing the pysical manifestation of deep-rooted shame through forcing the head into a lowered position',
      orientation: 'landscape'
    },
    {
      id: '70',
      image: 'exasperation',
      title: 'Exasperation',
      media: 'stainless steel, wool, plastic, leather',
      year: '2013',
      dimensions: "5' x 2' x 2'",
      description: 'A wearable, body-specific sculpture representing the pysical manifestation of inherent frustration and helplessness through inhibiting the utilitarian function of the hands',
      orientation: 'landscape'
    },
    {
      id: '71',
      image: 'exasperation_gallery',
      title: 'Exasperation',
      media: 'stainless steel, wool, plastic, leather',
      year: '2013',
      dimensions: "5' x 2' x 2'",
      description: 'A wearable, body-specific sculpture representing the pysical manifestation of inherent frustration and helplessness through inhibiting the utilitarian function of the hands',
      orientation: 'landscape'
    },
    {
      id: '72',
      image: 'projection...identification...empathy_installation_overview',
      title: 'projection...identification...empathy',
      media: 'multimedia: wool, stainless steel, found objects, video',
      year: '2013',
      dimensions: 'variable dimensions',
      description: 'Four wearable sculptures representing intangible feelings translated into physical form. Each object attaches to a specific part of the body and limits the mobility of that area. These devices composed of steel, fiber and plastic are not easily identifiable and retain qualities of clothing, corrective braces, traps, and living organisms. Accompanying video, showing a person interacting with the work, is projected onto screens and the sculptures themselves.',
      orientation: 'landscape'
    },
    {
      id: '73',
      image: 'projection...identification...empathy_gallery_performance',
      title: 'projection...identification...empathy',
      media: 'multimedia: wool, stainless steel, found objects, video',
      year: '2013',
      dimensions: 'variable dimensions',
      description: 'Four wearable sculptures representing intangible feelings translated into physical form. Each object attaches to a specific part of the body and limits the mobility of that area. These devices composed of steel, fiber and plastic are not easily identifiable and retain qualities of clothing, corrective braces, traps, and living organisms. Accompanying video, showing a person interacting with the work, is projected onto screens and the sculptures themselves.',
      orientation: 'landscape'
    },
    {
      id: '74',
      image: 'projection...identification...empathy_outside',
      title: 'projection...identification...empathy',
      media: 'multimedia: wool, stainless steel, found objects, video',
      year: '2013',
      dimensions: 'variable dimensions',
      description: 'Four wearable sculptures representing intangible feelings translated into physical form. Each object attaches to a specific part of the body and limits the mobility of that area. These devices composed of steel, fiber and plastic are not easily identifiable and retain qualities of clothing, corrective braces, traps, and living organisms. Accompanying video, showing a person interacting with the work, is projected onto screens and the sculptures themselves.',
      orientation: 'landscape'
    },
    {
      id: '75',
      image: 'chagrin_outside',
      title: 'Chagrin',
      media: 'stainless steel, wool, silicone, aluminum, leather',
      year: '2013',
      dimensions: "5' x 2' x 2'",
      description: 'A wearable, body-specific sculpture representing the pysical manifestation of deep-rooted shame through forcing the head into a lowered position',
      orientation: 'landscape'
    },
    {
      id: '76',
      video: 'https://player.vimeo.com/video/77461932?h=d797da9ed2&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'Self-Incarceration',
      media: 'stainless steel, wool, plastic, silicone, leather',
      year: '2013',
      dimensions: "7' x 2.5' x 2.5'",
      description: 'Video of the participant interacting with a body-specific sculpture representing the pysical manifestation of deep-rooted shame through forcing the head into a lowered position'
    },
    {
      id: '77',
      video: 'https://player.vimeo.com/video/78472421?h=bb8fb45334&amp;;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'Codependency',
      media: 'stainless steel, wool, plastic, leather',
      year: '2013',
      dimensions: "2' x 7' x 2'",
      description: 'Video of the participant interacting with a body-specific sculpture representing the pysical manifestation of emotional dependence on another person through linking the bodies together in an inexorable way'
    },
    {
      id: '78',
      video: 'https://player.vimeo.com/video/77461933?h=901a422bf9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'Chagrin',
      media: 'stainless steel, wool, silicone, aluminum, leather',
      year: '2013',
      dimensions: "5' x 2' x 2'",
      description: 'Video of the participant interacting with a body-specific sculpture representing the pysical manifestation of deep-rooted shame through forcing the head into a lowered position'
    },
    {
      id: '79',
      video: 'https://player.vimeo.com/video/78472420?h=7d87904df4&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'Exasperation',
      media: 'stainless steel, wool, plastic, leather',
      year: '2013',
      dimensions: "5' x 2' x 2'",
      description: 'Video of the participant interacting with a body-specific sculpture representing the pysical manifestation of inherent frustration and helplessness through inhibiting the utilitarian function of the hands'
    },
    {
      id: '80',
      video: 'https://player.vimeo.com/video/112092571?h=28da9604ec&;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'Exasperation',
      media: 'stainless steel, wool, plastic, leather',
      year: '2013',
      dimensions: "5' x 2' x 2'",
      description: 'Video of the participant performing the everyday action of eating while wearing a body-specific sculpture representing the pysical manifestation of inherent frustration and helplessness through inhibiting the utilitarian function of the hands'
    }
  ]
};

export const bodySculpturesImage: Images = {
  title: 'Body Sculptures',
  imageList: [
    {
      id: '81',
      image: 'hands_tied',
      title: 'Hands Tied',
      media: 'steel, cotton, beeswax',
      year: '2011',
      dimensions: '14" x 38" x 31"',
      description: 'Crocheted cotton dipped in beeswax and woven metal sculpture referencing the human body',
      orientation: 'landscape'
    },
    {
      id: '82',
      image: 'onus',
      title: 'Onus',
      media: 'steel, plastic, mulberry paper',
      year: '2011',
      dimensions: '18" x 22" x 28"',
      description: 'Crocheted plastic and woven metal sculpture referencing the human body',
      orientation: 'portrait'
    },
    {
      id: '83',
      image: 'onus_body',
      title: 'Onus',
      media: 'steel, plastic, mulberry paper',
      year: '2011',
      dimensions: '18" x 22" x 28"',
      description: 'Crocheted plastic and woven metal sculpture referencing the human body',
      orientation: 'portrait'
    }
  ]
};

export const osteodermImage: Images = {
  title: 'Osteoderm',
  imageList: [
    {
      id: '84',
      image: 'osteoderm',
      title: 'Osteoderm',
      media: 'anodized aluminum, waxed linen',
      year: '2011',
      dimensions: '5.5" x 5.5" x 5"',
      description: 'A body-oriented, site-specific object referencing animal armor and decorative clothing',
      orientation: 'portrait'
    },
    {
      id: '85',
      image: 'osteoderm_body',
      title: 'Osteoderm',
      media: 'anodized aluminum, waxed linen',
      year: '2011',
      dimensions: '5.5" x 5.5" x 5"',
      description: 'A body-oriented, site-specific object referencing animal armor and decorative clothing',
      orientation: 'landscape'
    },
  ]
};

export const phalangealThelodontsImage: Images = {
  title: 'Phalangeal Thelodonts',
  imageList: [
    {
      id: '86',
      image: 'phalangeal_thelodonts',
      title: 'Phalangeal Thelodonts',
      media: 'steel, waxed linen',
      year: '2011',
      dimensions: '13"x 11"x 7"',
      description: 'A body-oriented, site-specific object referencing animal traps and armor',
      orientation: 'landscape'
    },
    {
      id: '87',
      image: 'phalangeal_thelodonts_detail',
      title: 'Phalangeal Thelodonts',
      media: 'steel, waxed linen',
      year: '2011',
      dimensions: '13"x 11"x 7"',
      description: 'A body-oriented, site-specific object referencing animal traps and armor',
      orientation: 'landscape'
    },
  ]
};

export const defenseMechanismImage: Images = {
  title: 'Defense Mechanism',
  imageList: [
    {
      id: '88',
      image: 'defense_mechanism',
      title: 'Defense Mechanism',
      media: 'anodized aluminum, steel',
      year: '2011',
      dimensions: '5" x 6" x 3.5"',
      description: 'A body-oriented, site-specific object referencing clothing, armor and torture devices',
      orientation: 'landscape'
    },
    {
      id: '89',
      image: 'defense_mechanism_body_palm',
      title: 'Defense Mechanism',
      media: 'anodized aluminum, steel',
      year: '2011',
      dimensions: '5" x 6" x 3.5"',
      description: 'A body-oriented, site-specific object referencing clothing, armor and torture devices',
      orientation: 'landscape'
    },
    {
      id: '90',
      image: 'defense_mechanism_body',
      title: 'Defense Mechanism',
      media: 'anodized aluminum, steel',
      year: '2011',
      dimensions: '5" x 6" x 3.5"',
      description: 'A body-oriented, site-specific object referencing clothing, armor and torture devices',
      orientation: 'landscape'
    },
  ]
};

export const epithelialNeoplasmsImage: Images = {
  title: 'Epithelial Neoplasms',
  imageList: [
    {
      id: '91',
      image: 'epithelial_neoplasms_body',
      title: 'Epithelial Neoplasms',
      media: 'copper, enamel, monofilament, steel, sterling silver',
      year: '2009',
      dimensions: '18" x 13" x 10"',
      description: 'A body-oriented, site-specific necklace that also fits together to complete a bulbous form referencing tumors and growth in nature',
      orientation: 'portrait'
    },
    {
      id: '92',
      image: 'epithelial_neoplasms',
      title: 'Epithelial Neoplasms',
      media: 'copper, enamel, monofilament, steel, sterling silver',
      year: '2009',
      dimensions: '18" x 13" x 10"',
      description: 'A body-oriented, site-specific necklace that also fits together to complete a bulbous form referencing tumors and growth in nature',
      orientation: 'landscape'
    },
    {
      id: '93',
      image: 'epithelial_neoplasms_together',
      title: 'Epithelial Neoplasms',
      media: 'copper, enamel, monofilament, steel, sterling silver',
      year: '2009',
      dimensions: '18" x 13" x 10"',
      description: 'A body-oriented, site-specific necklace that also fits together to complete a bulbous form referencing tumors and growth in nature',
      orientation: 'landscape'
    },
  ]
};

export const apotheciaImage: Images = {
  title: 'Apothecia',
  imageList: [
    {
      id: '94',
      image: 'apothecia_body',
      title: 'Apothecia',
      media: 'cast paper, aluminum, copper',
      year: '2009',
      dimensions: '25" x 15" x 18"',
      description: 'A body-oriented necklace composed of bulbous forms representing rapid natural growth',
      orientation: 'portrait'
    },
    {
      id: '95',
      image: 'apothecia_side',
      title: 'Apothecia',
      media: 'cast paper, aluminum, copper',
      year: '2009',
      dimensions: '25" x 15" x 18"',
      description: 'A body-oriented necklace composed of bulbous forms representing rapid natural growth',
      orientation: 'portrait'
    }
  ]
};

export const burdensomeImage: Images = {
  title: 'Burdensome',
  imageList: [
    {
      id: '96',
      image: 'burdensome_detail',
      title: 'Burdensome',
      media: 'performance, video, sculpture: steel, plastic',
      year: '2016',
      dimensions: '37" x 22" x 16"',
      description: 'Still from the performance of eating an apple while wearing a body-specific sculpture inhibiting the function of the head and hand',
      orientation: 'landscape'
    },
    {
      id: '97',
      image: 'burdensome',
      title: 'Burdensome',
      media: 'performance, video, sculpture: steel, plastic',
      year: '2016',
      dimensions: '37" x 22" x 16"',
      description: 'Still from the performance of eating an apple while wearing a body-specific sculpture inhibiting the function of the head and hand',
      orientation: 'portrait'
    },
    {
      id: '98',
      video: 'https://player.vimeo.com/video/229367054?h=eb8f3a0e88&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
      title: 'Burdensome',
      media: 'performance, video, sculpture: steel, plastic',
      year: '2016',
      dimensions: '37" x 22" x 16"',
      description: 'Video of the performance of eating an apple while wearing a body-specific sculpture inhibiting the function of the head and hand',
    }
  ]
};